import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import { SanitizeHtml, withSize } from '@bd/bdcore-utilities';

import { BtnAnimationSheen } from '../helpers/UIElements';
import Accordion from './Accordion';
import { colors } from '../styles';

const styles = css`
  position: relative;
  margin-bottom: 20px;
  @media(min-width: 992px) {
    margin-bottom: 90px;
  }
  @media(min-width: 1200px) {
    margin-bottom: 180px;
  }
  .Accordion_row {
    padding-top: 100px;
  }
  .Accordion_wrapper {
    margin: 0 0 20px;
    border-bottom: 1px solid #DADADA;
    border-left: 1px solid #DADADA;
    border-right: 1px solid #DADADA;
    @media(min-width: 992px) {
      margin: 0 0 30px;
    }
  }
  .AccordionToggle_content {
    background-color: ${colors.color3};
    margin-bottom: 20px;
  }
  .Accordion_button:focus {
    outline:none
  }
  .DetailSection_heading {
    background-color: #DADADA;
    min-height: 50px;
    display: flex;
    align-items: center;
    padding: 10px 20px;
    position: relative;
    @media(min-width: 992px) {
      padding: 0 25px 0 0;
      height: 80px;
    }
    &::after {
      content: '';
      position: absolute;
      right: 17px;
      top: 50%;
      transform: translateY(-50%);
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 10px solid ${colors.color1};
      @media(min-width: 992px) {
        right: 30px;
      }
    }
  }
  .DetailSection_heading-open {
    &::after {
      border-bottom: 10px solid ${colors.color1};
      border-top: 10px solid transparent;
      top: 44%;
    }
  }
  .FeatureAccordion_title {
    font-weight: 700;
    line-height: 30px;
    color: rgb(0,0,0);
    letter-spacing: 2.5px;
    text-transform: uppercase;
    position: relative;
    padding: 0 20px 0 45px;
    @media(min-width: 992px) {
      padding: 0 0 0 25px;
      font-size: 19px;
    }
  }
  .FeatureSection_body {
    padding: 20px 10px;
    @media(min-width: 992px) {
      padding: 20px;
    }
  }
  .FeatureAccordion_body {
    position: relative;
    padding: 0 0 0 40px;
    font-weight: 300;
    font-size: 18px;
    line-height: 35px;
  } ul {
    padding-left: 0;
    padding-right: 2rem;
    list-style: none;
  } li {
    text-align: left;
    width: 100%;
    position: relative;
    font-weight: 300;
    font-size: 16px;
    line-height: 28px;
    padding: 0px 0px 20px;
    margin: 0px 0px 0px 30px;
  } li::after {
    content: "";
    width: 10px;
    height: 10px;
    background-color: rgb(128,128,128);
    position: absolute;
    left: -30px;
    top: 9px;
  }
    @media(min-width: 992px) {
      padding: 0 0 0 55px;
    }
  }
  .PlansResults_wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .FeatureAccordion_btnWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 0;
    @media(min-width: 992px) {
      padding: 45px 0;
    }
  }
  .FeatureAccordion_btn {
    height: 45px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: 0.12px;
    background-color: ${colors.color1};
    cursor: pointer;
    @media(min-width: 992px) {
      height: 55px;
      padding: 0 35px;
      font-size: 17px;
      letter-spacing: 0;
    }
    &:focus {
      outline: none;
    }
  }
`;

const increment = 6;

class FeatureAccordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: increment,
    };
  }
  showMoreQuestions = () => {
    this.setState({ limit: this.state.limit + increment });
  }
  render() {
    const { limit } = this.state;
    const { list, size } = this.props;
    const imagesLeft = `${limit + increment > list.length ? list.length - limit : increment}`;
    return (
      <div className={styles}>
        <div className="container">
          <div className="row Accordion_row">
            <div className="col-sm-10 mx-sm-auto AccordionWrapper DetailSection">
              <div id="description flex-column" />
              {list.slice(0, limit).map(item => (
                <Accordion
                  key={item._id}
                  button={({ contentVisible }) => (
                    <div className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>
                      <div className="FeatureAccordion_title">{get(item, 'title')}</div>
                    </div>
                  )}
                >
                  <div className="FeatureSection_body d-lg-flex">
                    <div className="FeatureAccordion_body" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'content'))} />
                  </div>
                </Accordion>
              ),
              )}
            </div>
          </div>
          {
            limit < list.length &&
            <div className="FeatureAccordion_btnWrapper">
              <span className="FeatureAccordion_text">Showing {limit} of {list.length} Features</span>
              <BtnAnimationSheen className="FeatureAccordion_btn mt-3" onClick={this.showMoreQuestions} role="button" tabIndex={0}>{`Load${size.width >= 992 ? ` ${imagesLeft}` : ''} More${size.width >= 992 ? ' Features' : ''}`}</BtnAnimationSheen>
            </div>
          }
        </div>
      </div>
    );
  }
}

FeatureAccordion.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  size: PropTypes.object.isRequired,
};

export default withSize()(FeatureAccordion);



// WEBPACK FOOTER //
// ./src/components/FeatureAccordion.js